import React, { useEffect, useState } from "react";
import BackButton from "../components/BackButton";
import { client, generateImage } from '../Script'
import { UpdateAnalytics, UpdateUserLimits } from '../Firebase'
import DownloadBtn from '../assets/download-minimalistic-svgrepo-com.svg'
import DownloadSquare from '../assets/download-square-svgrepo-com.png'


export default function Chat() {

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [typingMessage, setTypingMEssage] = useState("");
  const [chatType, setChatType] = useState("")
  const [showAlert, setshowAlert] = useState(false)
  const [isIos, setIsIos] = useState(false)
  const [generatedImage, setGenerated] = useState('')


  async function downloadImage(imageUrl) {

    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'generate.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    alert("Image is downloaded")
  }


  const detectMobileOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setIsIos(true)
    }
  }



  function addMessageToArray(sender, message) {
    setMessages((prevMessages) => [
      ...prevMessages,
      { text: message, sender: sender },
    ]);
  }




  async function sendMessage(message) {

    const userData = JSON.parse(localStorage.getItem("AI_UserData"))
    const phone = userData.phone
    const limit = userData.image_generation_limit

    setTyping(true)
    setInput("")
    console.log("Requesting OpenAI...");

    if (message) {

      addMessageToArray("user", message)

      if (chatType === "image") {

        if (limit === 0) {
          setshowAlert(true)
          setTyping(false)
        } else {
          setTypingMEssage("Generating ...")
          //const imageResponse = await generateImage(message)
          const imageResponse = await testApi(message)
          console.log(imageResponse)
          addMessageToArray("bot", imageResponse)
          setTyping(false)
          UpdateUserLimits("image_generation_limit", phone, 1)
          UpdateAnalytics("image_generation")
        }


      }

      if (chatType === "chat") {
        setTypingMEssage("Typing  ...")

        const chatCompletion = await client.chat.completions.create({
          model: "gpt-3.5-turbo", // Specify the model
          messages: [{ role: "user", content: message }], // Messages for the chat
        });
        console.log("AI Response : ", chatCompletion.choices[0].message); // Log the AI's response
        setTyping(false)
        addMessageToArray("bot", chatCompletion.choices[0].message.content)
        UpdateAnalytics("text_chat")
      }


    }
    else {
      setTypingMEssage("Typing ...")

      const chatCompletion = await client.chat.completions.create({
        model: "gpt-3.5-turbo", // Specify the model
        messages: [{ role: "user", content: "Hi" }], // Messages for the chat
      });
      console.log("AI Response : ", chatCompletion.choices[0].message); // Log the AI's response
      setTyping(false)

      addMessageToArray("bot", chatCompletion.choices[0].message.content)
    }

  }


  useEffect(() => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const chattype = urlParams.get('type')
    setChatType(chattype)


    async function fetchInitialMessage() {
      await sendMessage();
    }
    fetchInitialMessage();
    detectMobileOS()

  }, []);


  async function testApi(prompt) {
    console.log("Testing ...");

    // Make the POST request to the Firebase function
    const response = await fetch('https://test-y5s4sffvfa-uc.a.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt: prompt }),
    });

    if (response.ok) {
      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);

      return (imageUrl)
      // const imgElement = document.createElement('img');
      // imgElement.src = imageUrl;
      // document.body.appendChild(imgElement); // Append the image to the page
    } else {
      console.error("Error generating image:", response.statusText);
    }
  }





  return (
    <div className="pt-4"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}>

      <div className="container" >
        {chatType === "chat" ? <BackButton title="AI Chat" /> :
          <BackButton title="AI Image Generator" />}

        {showAlert ? (<div className={`alert alert-danger alert-dismissible fade show`} data-aos='fade-right' role="alert">
          <h3>You have reached your generation limit !</h3>
        </div>) : ""}
      </div>


      {/* Scrollable Chat Section */}
      <div
        className="container chat-section d-flex flex-column"
        style={{
          height: '75vh',
          overflow: 'auto',
          paddingBottom: '10rem',
        }}
      >
        {messages.map((msg, index) => (
          <div
            className="bold text-dark"
            key={index}
            style={{
              boxShadow:
                msg.sender === 'user'
                  ? '-7px 8px 7px rgba(0, 0, 0, 0.1)'
                  : '7px 8px 7px rgba(0, 0, 0, 0.1)',
              padding: '10px',
              margin: '15px 0',
              fontSize: '1.2rem',
              maxWidth: '70%',
              borderRadius: '5px',
              position: 'relative',
              alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
              background: '#f1f1f1', // Set transparent background for bot
              textAlign: msg.sender === 'user' ? 'right' : 'left',
            }}
          >
            {/* Render message text for user */}
            {msg.sender === 'user' ? (
              msg.text
            ) : chatType === 'image' ? (
              index === 0 ? (
                msg.text // Render text if index = 0
              ) : (
                <div className="d-flex flex-column align-items-start justify-content-center" style={{position:'relative'}} >
                  <img className="w-100" style={{borderRadius:'5px'}} src={msg.text} alt="Generated" />


                  {isIos ? ( 
                    <div className="d-flex flex-row align-items-center justify-content-center mt-1 " 
                    style={{position:'absolute' , top:'2px' , left:'5px' , background:'white' , padding:'2px 5px' ,borderRadius:'5px' , border:'1px solid #000000a1'}}>
                      <img style={{width:'15px'}} src={DownloadSquare} />
                      <p className="p-1 m-0 text-dark">hold the image to download</p>
                      </div>)
                  :
                   (<div className="d-flex flex-row align-items-center justify-content-center mt-1 "
                    style={{ border: '1px solid black', borderRadius: '5px', width: '100%', cursor: 'pointer' }}
                    onClick={() => downloadImage(msg.text)} >

                    <h2 className="p-2 m-0">Download</h2>
                    <img style={{ width: '18px' }} src={DownloadBtn} />
                  </div>)}



                </div>
              )
            ) : (
              msg.text // Render text for non-image chat types
            )}
          </div>
        ))}

        {/* Display loader as the last message */}
        {typing && (
          <div className="ChatLoader">  </div>
        )}

      </div>





      {/* Fixed Chat Controls */}
      <div className=" container chat-controls"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          padding: "10px",
          background: '#FED501'
        }}>

        <input id='messageInput' type="text" placeholder="Ask Anything!" value={input} onChange={(e) => setInput(e.target.value)}
          style={{
            flex: 1,
            padding: "15px",
            borderRadius: "10px",
            outline: "none"
          }}
        />
        <button
          onClick={() => sendMessage(input)}
          className="main-button mt-2 bold">
          Send Message
        </button>
      </div>
    </div>
  );
}
